module.exports = __webpack_public_path__ + "static/media/22ESCWA23.1b713c51.jpg";